import { Message } from './types'
import { MessageCacheBase } from './message-cache-base'
import { MessageCacheIndexedDBDriver } from './message-cache-indexed-db-driver'
// import { MessageCacheIndexedDBWorkerDriver as MessageCacheIndexedDBDriver } from './message-cache-indexed-db-worker-driver'

export class MessageCacheIndexedDB extends MessageCacheBase {
  protected driver: MessageCacheIndexedDBDriver

  constructor (maxCount: number) {
    super(maxCount)
    this.driver = new MessageCacheIndexedDBDriver('bv-message-cache')
    // remove old version DBs
    this.driver.deleteDatabases('bv-message-cache-')
  }

  protected async _load (chatRoomId: number) {
    return await this.driver.load(chatRoomId)
  }

  protected async _reset (): Promise<void> {
    await this.driver.reset()
  }

  protected async _put (mesgs: Message[]): Promise<void> {
    await this.driver.put(mesgs)
  }

  protected async _delete (mesgs: Message[]): Promise<void> {
    await this.driver.delete(mesgs)
  }
}
